import React, { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { TrashIcon, FlagIcon } from '@heroicons/react/24/solid';
import './ModerationButton.css';

interface ModerationButtonProps {
    postId: number;
    onClick: () => void;
    facebookVoteCount?: number;
    onFacebook?: boolean;
    isTrashed?: boolean;
    orthoCorrection?: string;
}

const ModerationButton: React.FC<ModerationButtonProps> = ({
    postId,
    onClick,
    facebookVoteCount = 0,
    onFacebook = false,
    isTrashed = false,
    orthoCorrection
}) => {
    const { isModerator } = useContext(UserContext);

    // Only show for moderators
    if (!isModerator()) {
        return null;
    }

    const hasFacebookVotes = facebookVoteCount > 0;
    const hasOrthoCorrection = orthoCorrection && orthoCorrection.trim() !== '';

    return (
        <button
            type="button"
            className={`ModerationButton ${isTrashed ? 'trashed' : (onFacebook ? 'promoted' : '')} ${hasOrthoCorrection && !hasFacebookVotes && !onFacebook ? 'ortho-correction' : ''}`}
            onClick={onClick}
            title={isTrashed ? 'BD à la corbeille' : (onFacebook ? 'Promue sur Facebook' : (hasFacebookVotes ? `Facebook votes: ${facebookVoteCount}` : (hasOrthoCorrection ? `Correction demandée: ${orthoCorrection}` : 'Modération')))}
        >
            {isTrashed ? (
                <TrashIcon className="trash-icon" />
            ) : (!onFacebook && !hasFacebookVotes) ? (
                <FlagIcon className="flag" />
            ) : (
                <>
                    {hasFacebookVotes && <span className="count">{facebookVoteCount}</span>}
                    <span className="facebook-icon">f</span>
                </>
            )}
        </button>
    );
};

export default ModerationButton;
